import React, { useState } from 'react'
import styled from 'styled-components'
import { FaShoppingCart, FaTimes } from 'react-icons/fa';
import logo from '../assets/logo.png';
import { useCart } from '../context/CartContext';


const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { cartCount, setIsCartOpen, cartItems } = useCart();

    const totalPrice = cartItems.reduce((sum, item) => sum + item.totalPrice, 0).toFixed(2);


    return (
        <Nav>
            <Logo>
                <a href='/'>
                    <img src={logo} alt="Wildberries Logo" />
                </a>
            </Logo>

            <MobileIcons>
                <Hamburger onClick={() => setIsMenuOpen(!isMenuOpen)}>
                {isMenuOpen ? <FaTimes size={24} color='#f9f7f7'/> : (
                    <>
                        <span />
                        <span />
                        <span />
                    </>
                )}
                </Hamburger>

                <CartMobile onClick={() => setIsCartOpen(true)}>
                    <FaShoppingCart size={24} color="#f9f7f7" />
                    {cartCount > 0 && <CartCount>{cartCount}</CartCount>}
                </CartMobile>
            </MobileIcons>

            <NavLinks $isOpen={isMenuOpen}>
                <NavLink href="/">Hjem</NavLink>
                <NavLink href="/#about">Om Oss</NavLink>
                <NavLink href="/#stands">Våre Stands</NavLink>
                <NavLink href="/shop">Butikk</NavLink>
                <NavLink href="/#contact">Kontakt</NavLink>

                
                <CartDesktop onClick={() => setIsCartOpen(true)}>
                    <FaShoppingCart size={24} color="#f9f7f7" />
                    {cartCount > 0 && <CartCount>{cartCount}</CartCount>}
                    kr {totalPrice}
                </CartDesktop>
            </NavLinks>
            
            
        </Nav>
    )
}

export default Navbar

const Nav = styled.nav`
    background-color: #2d6a4f;
    height: 80px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 2rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 0;
    left: 0;
    z-index: 1000;
`;

const Logo = styled.h1`
    img {
        height: 100px; /* Adjust to fit the navbar height */
        cursor: pointer;
    }
`;

const NavLinks = styled.div`
    display: flex;
    align-items: center;
    gap: 2rem;


    @media (max-width: 768px) {
        flex-direction: column;
        position: absolute;
        top: 80px;
        left: 0;
        right: 0;
        background-color: #2d6a4f;
        padding: 1rem;
        z-index: 1000;
        gap: 1rem;

        transform: ${({ $isOpen }) => ($isOpen ? "translateY(0)" : "translateY(-100%)")};
        opacity: ${({ $isOpen }) => ($isOpen ? "1" : "0")};
        visibility: ${({ $isOpen }) => ($isOpen ? "visible" : "hidden")};
        transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
    }
`;

const NavLink = styled.a`
    font-size: 1rem;
    color: #f9f7f7;
    text-decoration: none;
    transition: color 0.3s;

    &:hover {
        color: #b7e4c7;
    }
`;

const Hamburger = styled.div`
    display: none;
    flex-direction: column;
    gap: 0.3rem;
    cursor: pointer;

    span {
        width: 25px;
        height: 3px;
        background-color: #f9f7f7;
    }

    @media (max-width: 768px) {
        display: flex;
    }
`;




const MobileIcons = styled.div`
    display: none;
    
    @media (max-width: 768px) {
        display: flex;
        align-items: center;
        gap: 1.5rem;
    }
`;

const CartMobile = styled.div`
    position: relative;
    display: none;
    
    @media (max-width: 768px) {
        display: block;
    }
`;

const CartDesktop = styled.div`
    position: relative;
    display: block;
    cursor: pointer;
    color: #fff;
    display: flex;
    align-items: center;
    gap: 5px;
    
    @media (max-width: 768px) {
        display: none;
    }
`;

const CartCount = styled.span`
    position: absolute;
    top: -8px;
    left: -10px;
    background-color: #f94144;
    color: #f9f7f7;
    font-size: 0.75rem;
    font-weight: bold;
    padding: 0.2rem 0.5rem;
    border-radius: 50%;
`;